// import React, { createContext, useState, useContext, useCallback } from "react";
// import {
//   createNewArchive,
//   updateArchive,
//   deleteArchive,
// } from "../../../../lib/firebase/archives/write";
// import { getArchive } from "../../../../lib/firebase/archives/read";
// import { useNavigate } from "react-router-dom";
// import { getDocs, collection } from "firebase/firestore";
// import { db } from "../../../../lib/firebase";
// // import { formatMonthYear } from "../../../../lib/utils/formatDate";

// const ArchiveFormContext = createContext();

// export function useArchiveForm() {
//   return useContext(ArchiveFormContext);
// }

// export default function ArchiveFormContextProvider({ children }) {
//   const [data, setData] = useState({});
//   const [documents, setDocuments] = useState([
//     { slug: "", title: "", author: "", pageNo: "", pdfFile: null },
//   ]);
//   const [isFetching, setIsFetching] = useState(false);
//   const [isUpdateLoading, setIsUpdateLoading] = useState(false);
//   const [isDeleteLoading, setIsDeleteLoading] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [error, setError] = useState("");
//   const [isDone, setIsDone] = useState(false);
//   const [validationErrors, setValidationErrors] = useState({}); // New state for validation
//   const navigate = useNavigate();

//   const handleData = useCallback((key, value) => {
//     setIsDone(false);
//     setError("");
//     setValidationErrors((prev) => ({ ...prev, [key]: "" })); // Clear error for this field
//     setData((prevData) => ({
//       ...prevData,
//       [key]: value,
//     }));
//   }, []);

//   const handleDocumentChange = useCallback((index, key, value) => {
//     setIsDone(false);
//     setError("");
//     setValidationErrors((prev) => {
//       const newDocErrors = [...(prev.documents || [])];
//       newDocErrors[index] = { ...newDocErrors[index], [key]: "" }; // Clear error for this document field
//       return { ...prev, documents: newDocErrors };
//     });
//     setDocuments((prevDocs) => {
//       const newDocs = [...prevDocs];
//       newDocs[index] = { ...newDocs[index], [key]: value };
//       return newDocs;
//     });
//   }, []);

//   const addDocument = useCallback(() => {
//     setDocuments((prevDocs) => [
//       ...prevDocs,
//       { slug: "", title: "", author: "", pageNo: "", pdfFile: null },
//     ]);
//   }, []);

//   const removeDocument = useCallback((index) => {
//     setDocuments((prevDocs) => prevDocs.filter((_, i) => i !== index));
//     setValidationErrors((prev) => {
//       const newDocErrors = [...(prev.documents || [])].filter(
//         (_, i) => i !== index
//       );
//       return { ...prev, documents: newDocErrors };
//     });
//   }, []);

//   const resetForm = useCallback(() => {
//     setData({});
//     setDocuments([
//       { slug: "", title: "", author: "", pageNo: "", pdfFile: null },
//     ]);
//     setError("");
//     setIsDone(false);
//     setValidationErrors({});
//     setSuccessMessage("");
//   }, []);

//   const validateForm = useCallback(() => {
//     const errors = {};
//     // Validate archive-level fields
//     if (!data.publishedBy) errors.publishedBy = "Required";
//     if (!data.categoryId) errors.categoryId = "Required";
//     if (!data.timestamp) errors.timestamp = "Required";
//     if (!data.metaTitle) errors.metaTitle = "Required";
//     if (!data.metaDescription) errors.metaDescription = "Required";

//     // Validate document-level fields
//     const docErrors = documents.map((doc, index) => {
//       const docError = {};
//       if (!doc.slug) docError.slug = "Required";
//       if (!doc.title) docError.title = "Required";
//       if (!doc.author) docError.author = "Required";
//       if (!doc.pageNo) docError.pageNo = "Required";
//       if (!doc.pdfFile && !doc.pdfUrl) docError.pdfFile = "Required";
//       return docError;
//     });

//     if (docErrors.some((err) => Object.keys(err).length > 0)) {
//       errors.documents = docErrors;
//     }

//     setValidationErrors(errors);
//     return Object.keys(errors).length === 0; // Return true if no errors
//   }, [data, documents]);

//   const handleCreate = useCallback(
//     async (collectionName = "Archive") => {
//       if (!validateForm()) {
//         setError("Please fill all required fields.");
//         return;
//       }
//       setError("");
//       setIsUpdateLoading(true);
//       setIsDone(false);
//       try {
//         console.log(
//           "Creating archive with data:",
//           data,
//           "documents:",
//           documents
//         );
//         await createNewArchive({ data, documents, collectionName });
//         setIsDone(true);
//         setSuccessMessage("Archive created successfully!");
//         resetForm();
//         console.log("Archive created successfully, form state reset");
//         setTimeout(() => setIsDone(false), 3000);
//       } catch (error) {
//         console.error("Create Error:", error);
//         setError(
//           error.message ||
//             "Failed to create archive. Please check your input and try again."
//         );
//       } finally {
//         setIsUpdateLoading(false);
//       }
//     },
//     [data, documents, validateForm, resetForm]
//   );

//   const handleUpdate = useCallback(
//     async (collectionName = "Archive", monthYear) => {
//       if (!validateForm()) {
//         setError("Please fill all required fields.");
//         return;
//       }
//       setError("");
//       setIsUpdateLoading(true);
//       setIsDone(false);
//       try {
//         if (!data?.id) throw new Error("No ID provided for update");
//         console.log(
//           "Updating archive:",
//           data,
//           "documents:",
//           documents,
//           "monthYear:",
//           monthYear
//         );
//         await updateArchive({ data, documents, collectionName });
//         setIsDone(true);
//         setSuccessMessage("Archive updated successfully!");
//         console.log("Archive updated successfully, form state retained");
//         setTimeout(() => setIsDone(false), 3000);
//       } catch (error) {
//         console.error("Update Error:", error);
//         setError(error.message || "Failed to update archive");
//       } finally {
//         setIsUpdateLoading(false);
//       }
//     },
//     [data, documents, validateForm]
//   );

//   const handleDelete = useCallback(
//     async (id, monthYear, collectionName = "Archive") => {
//       setError("");
//       setIsDeleteLoading(true);
//       setIsDone(false);
//       try {
//         if (!id) throw new Error("No ID provided for deletion");
//         if (!monthYear) throw new Error("Month and year required for deletion");
//         console.log("Deleting archive:", { collectionName, id, monthYear });
//         await deleteArchive(id, monthYear, collectionName);
//         setIsDone(true);
//         setSuccessMessage("Archive deleted successfully!");
//         console.log("Archive deleted successfully");
//         setTimeout(() => {
//           setIsDone(false);
//           navigate("/admin/archives");
//         }, 3000);
//       } catch (error) {
//         console.error("Delete Error:", error);
//         setError(error.message || "Failed to delete archive");
//       } finally {
//         setIsDeleteLoading(false);
//       }
//     },
//     [navigate]
//   );

//   const fetchData = useCallback(
//     async (id, monthYear, collectionName = "Archive") => {
//       setError("");
//       setIsFetching(true);
//       setIsDone(false);
//       try {
//         console.log("Fetching archive:", { collectionName, id });
//         const res = await getArchive(id, monthYear, collectionName);
//         if (res.exists()) {
//           const fetchedData = res.data();
//           console.log("Fetched Archive Data:", fetchedData);
//           setData(fetchedData);
//           const docsSnapshot = await getDocs(
//             collection(db, `${collectionName}/${id}/Documents`)
//           );
//           const docsData = docsSnapshot.docs.map((doc) => ({
//             id: doc.id,
//             ...doc.data(),
//             pdfFile: null,
//           }));
//           setDocuments(
//             docsData.length > 0
//               ? docsData
//               : [{ slug: "", title: "", author: "", pageNo: "", pdfFile: null }]
//           );
//         } else {
//           throw new Error(`No archive found for id ${id}`);
//         }
//       } catch (error) {
//         console.error("Fetch Error:", error);
//         setError(error.message || "Failed to fetch archive");
//       } finally {
//         setIsFetching(false);
//       }
//     },
//     []
//   );

//   return (
//     <ArchiveFormContext.Provider
//       value={{
//         data,
//         handleData,
//         documents,
//         handleDocumentChange,
//         addDocument,
//         removeDocument,
//         isFetching,
//         isUpdateLoading,
//         isDeleteLoading,
//         error,
//         isDone,
//         successMessage,
//         handleCreate,
//         handleUpdate,
//         handleDelete,
//         fetchData,
//         resetForm,
//         validationErrors, // New
//       }}
//     >
//       {children}
//     </ArchiveFormContext.Provider>
//   );
// }

import React, { createContext, useState, useContext, useCallback } from "react";
import {
  createNewArchive,
  updateArchive,
  deleteArchive,
} from "../../../../lib/firebase/archives/write";
import { getArchive } from "../../../../lib/firebase/archives/read";
import { useNavigate } from "react-router-dom";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../../../../lib/firebase";
// import { formatMonthYear } from "../../../../lib/utils/formatDate";

const ArchiveFormContext = createContext();

export function useArchiveForm() {
  return useContext(ArchiveFormContext);
}

export default function ArchiveFormContextProvider({ children }) {
  const [data, setData] = useState({});
  const [documents, setDocuments] = useState([
    { slug: "", title: "", author: "", pageNo: "", pdfFile: null },
  ]);
  const [isFetching, setIsFetching] = useState(false);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [isDone, setIsDone] = useState(false);
  const [validationErrors, setValidationErrors] = useState({}); // New state for validation
  const navigate = useNavigate();

  const handleData = useCallback((key, value) => {
    setIsDone(false);
    setError("");
    setValidationErrors((prev) => ({ ...prev, [key]: "" })); // Clear error for this field
    setData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  }, []);

  const handleDocumentChange = useCallback((index, key, value) => {
    setIsDone(false);
    setError("");
    setValidationErrors((prev) => {
      const newDocErrors = [...(prev.documents || [])];
      newDocErrors[index] = { ...newDocErrors[index], [key]: "" }; // Clear error for this document field
      return { ...prev, documents: newDocErrors };
    });
    setDocuments((prevDocs) => {
      const newDocs = [...prevDocs];
      newDocs[index] = { ...newDocs[index], [key]: value };
      return newDocs;
    });
  }, []);

  const addDocument = useCallback(() => {
    setDocuments((prevDocs) => [
      ...prevDocs,
      { slug: "", title: "", author: "", pageNo: "", pdfFile: null },
    ]);
  }, []);

  const removeDocument = useCallback((index) => {
    setDocuments((prevDocs) => prevDocs.filter((_, i) => i !== index));
    setValidationErrors((prev) => {
      const newDocErrors = [...(prev.documents || [])].filter(
        (_, i) => i !== index
      );
      return { ...prev, documents: newDocErrors };
    });
  }, []);

  const resetForm = useCallback(() => {
    setData({});
    setDocuments([
      { slug: "", title: "", author: "", pageNo: "", pdfFile: null },
    ]);
    setError("");
    setIsDone(false);
    setValidationErrors({});
    // setSuccessMessage("");
  }, []);

  const validateForm = useCallback(() => {
    const errors = {};
    // Validate archive-level fields
    if (!data.publishedBy) errors.publishedBy = "Required";
    if (!data.categoryId) errors.categoryId = "Required";
    if (!data.timestamp) errors.timestamp = "Required";
    if (!data.metaTitle) errors.metaTitle = "Required";
    if (!data.metaDescription) errors.metaDescription = "Required";

    // Validate document-level fields
    const docErrors = documents.map((doc, index) => {
      const docError = {};
      if (!doc.slug) docError.slug = "Required";
      if (!doc.title) docError.title = "Required";
      if (!doc.author) docError.author = "Required";
      if (!doc.pageNo) docError.pageNo = "Required";
      if (!doc.pdfFile && !doc.pdfUrl) docError.pdfFile = "Required";
      return docError;
    });

    if (docErrors.some((err) => Object.keys(err).length > 0)) {
      errors.documents = docErrors;
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  }, [data, documents]);

  const handleCreate = useCallback(
    async (collectionName = "Archive") => {
      if (!validateForm()) {
        setError("Please fill all required fields.");
        return;
      }
      setError("");
      setIsUpdateLoading(true);
      setIsDone(false);
      try {
        // console.log(
        //   "Creating archive with data:",
        //   data,
        //   "documents:",
        //   documents
        // );
        await createNewArchive({ data, documents, collectionName });
        setIsDone(true);
        setSuccessMessage("Archive created successfully!");
        resetForm();
        // console.log("Archive created successfully, form state reset");
        setTimeout(() => setSuccessMessage(""), 3000);
      } catch (error) {
        console.error("Create Error:", error);
        setError(
          error.message ||
            "Failed to create archive. Please check your input and try again."
        );
      } finally {
        setIsUpdateLoading(false);
      }
    },
    [data, documents, validateForm, resetForm]
  );

  const handleUpdate = useCallback(
    async (collectionName = "Archive", monthYear) => {
      if (!validateForm()) {
        setError("Please fill all required fields.");
        return;
      }
      setError("");
      setIsUpdateLoading(true);
      setIsDone(false);
      try {
        if (!data?.id) throw new Error("No ID provided for update");
        console.log(
          "Updating archive:",
          data,
          "documents:",
          documents,
          "monthYear:",
          monthYear
        );
        await updateArchive({ data, documents, collectionName });
        setIsDone(true);
        setSuccessMessage("Archive updated successfully!");
        // console.log("Archive updated successfully, form state retained");
        setTimeout(() => setSuccessMessage(""), 3000);
      } catch (error) {
        console.error("Update Error:", error);
        setError(error.message || "Failed to update archive");
      } finally {
        setIsUpdateLoading(false);
      }
    },
    [data, documents, validateForm]
  );

  const handleDelete = useCallback(
    async (id, monthYear, collectionName = "Archive") => {
      setError("");
      setIsDeleteLoading(true);
      setIsDone(false);
      try {
        if (!id) throw new Error("No ID provided for deletion");
        if (!monthYear) throw new Error("Month and year required for deletion");
        console.log("Deleting archive:", { collectionName, id, monthYear });
        await deleteArchive(id, monthYear, collectionName);
        setIsDone(true);
        setSuccessMessage("Archive deleted successfully!");
        console.log("Archive deleted successfully");
        setTimeout(() => {
          setSuccessMessage("");
          navigate("/admin/archives");
        }, 3000);
      } catch (error) {
        console.error("Delete Error:", error);
        setError(error.message || "Failed to delete archive");
      } finally {
        setIsDeleteLoading(false);
      }
    },
    [navigate]
  );

  const fetchData = useCallback(
    async (id, monthYear, collectionName = "Archive") => {
      setError("");
      setIsFetching(true);
      setIsDone(false);
      try {
        console.log("Fetching archive:", { collectionName, id });
        const res = await getArchive(id, monthYear, collectionName);
        if (res.exists()) {
          const fetchedData = res.data();
          console.log("Fetched Archive Data:", fetchedData);
          setData(fetchedData);
          const docsSnapshot = await getDocs(
            collection(db, `${collectionName}/${id}/Documents`)
          );
          const docsData = docsSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
            pdfFile: null,
          }));
          setDocuments(
            docsData.length > 0
              ? docsData
              : [{ slug: "", title: "", author: "", pageNo: "", pdfFile: null }]
          );
        } else {
          throw new Error(`No archive found for id ${id}`);
        }
      } catch (error) {
        console.error("Fetch Error:", error);
        setError(error.message || "Failed to fetch archive");
      } finally {
        setIsFetching(false);
      }
    },
    []
  );

  return (
    <ArchiveFormContext.Provider
      value={{
        data,
        handleData,
        documents,
        handleDocumentChange,
        addDocument,
        removeDocument,
        isFetching,
        isUpdateLoading,
        isDeleteLoading,
        error,
        isDone,
        successMessage,
        handleCreate,
        handleUpdate,
        handleDelete,
        fetchData,
        resetForm,
        validationErrors, // New
      }}
    >
      {children}
    </ArchiveFormContext.Provider>
  );
}
